import DOMPurify, { type Config } from 'dompurify';

const SNIPPET_CONFIG: Config = {
  ALLOWED_TAGS: [
    'a',
    'b',
    'blockquote',
    'br',
    'button',
    'div',
    'em',
    'figure',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'hr',
    'i',
    'img',
    'li',
    'nav',
    'ol',
    'p',
    'picture',
    'section',
    'small',
    'source',
    'span',
    'strong',
    'u',
    'ul',
  ],
  ALLOWED_ATTR: [
    'alt',
    'aria-controls',
    'aria-expanded',
    'aria-hidden',
    'aria-label',
    'class',
    'data-action',
    'data-target',
    'height',
    'href',
    'loading',
    'media',
    'rel',
    'role',
    'sizes',
    'src',
    'srcset',
    'target',
    'title',
    'type',
    'width',
  ],
  ALLOW_DATA_ATTR: false,
  RETURN_DOM: false,
  RETURN_DOM_FRAGMENT: false,
};

export function sanitizeSnippetHtml(html: string | null | undefined): string {
  if (!html) return '';
  return DOMPurify.sanitize(html, SNIPPET_CONFIG) as string;
}
